import React, { useState } from 'react'

function Toggle({
  id1,
  id2,
  header,
  text1,
  text2,
  onClick,
  toggleButtonTheme1,
  toggleButtonTheme2,
}) {
  return (
    <div className="col-lg-4 col-md-12 col-sm-12 mt-3">
      <div
        className="btn-group btn-group-radio-tabs btn-group-toggle btn-group-lg d-block"
        data-toggle="buttons"
      >
        <div className="toggle-container">
          <div className="toggle-label">
            <h2 className="text-center">{header}</h2>
          </div>
          <div className="toggle-form">
            <label
              className={`btn w-50 onboarding-form bottom-border option-text ${toggleButtonTheme1}`}
              id={id1}
              onClick={onClick}
            >
              <input
                id="option1"
                autoComplete="off"
                checked=""
                name="options"
                type="radio"
              />
              {text1}
              <div className="btn-bottom-border" />
            </label>
            <label
              className={`btn w-50 onboarding-form bottom-border option-text ${toggleButtonTheme2}`}
              id={id2}
              onClick={onClick}
            >
              <input
                id="option2"
                autoComplete="off"
                name="options"
                type="radio"
              />
              {text2}
              <div className="btn-bottom-border" />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Toggle;
